import React from 'react'
import './Navbar.css'

const Navbar = () => {
  return (
    // <header className="header">
    <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="#home">
            Pratham01
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{backgroundColor: 'grey'}}>
          </button>
          <div className="collapse navbar-collapse justify-content-between" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#home">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#skills">Skills</a>
              </li>
            </ul>
            <ul className="navbar-nav ml-auto">
              <a href='#contact'>
                <button className="btn2">Contact Me!</button>
              </a>
            </ul>
          </div>
        </div>
      </nav>
// </header>
  )
}

export default Navbar